import { makeStyles } from 'tss-react/mui';

/**
 * Custom hook that defines the styles for the tag page component.
 */
const useTagPageStyles = makeStyles()(() => ({
  tagList: {
    display: 'grid',
    gridTemplateColumns: 'repeat(3, 1fr)',
    gridGap: '80px 20px',
  },
}));

export default useTagPageStyles;
